import React, { useState } from 'react';
import './CheckoutPage.css';
import Xendit from 'xendit-js-node';

const xendit = new Xendit({
    publicKey: 'YOUR_XENDIT_PUBLIC_KEY',
});

const CheckoutPage = () => {
    const [email, setEmail] = useState('');
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(false);

    const handlePayment = async () => {
        setLoading(true);
        try {
            // Initialize Xendit payment request here
            const token = await xendit.createToken({
                card_number: 'CREDIT_CARD_NUMBER',
                card_exp_month: 'MM',
                card_exp_year: 'YYYY',
                card_cvn: 'CVC',
                amount,
                currency: 'IDR',
            });
            console.log('Payment successful:', token);
        } catch (error) {
            console.error('Payment failed:', error);
        }
        setLoading(false);
    };

    return (
        <div className="checkout-section">
            <div className="checkout-container">
                <h2 className="checkout-header">Checkout</h2>
                <p className="checkout-subheader">Complete your purchase by providing your payment details below.</p>
                <input
                    type="email"
                    placeholder="Enter your email"
                    className="input-field"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="number"
                    placeholder="Amount"
                    className="input-field"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />
                <button
                    className="submit-button"
                    onClick={handlePayment}
                    disabled={loading}
                >
                    {loading ? 'Processing...' : 'Pay Now'}
                </button>
                <p className="footer-text">Your data is secure and protected.</p>
            </div>
        </div>
    );
};

export default CheckoutPage;
